var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        _vm.dense ? "dense" : "",
        _vm.filterable ? "sb-base-table2" : "",
        "sb-base-table",
        _vm.fullHeightTable ? "sb_full_height_table" : ""
      ]
    },
    [
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500px", persistent: "" },
          model: {
            value: _vm.openDialog,
            callback: function($$v) {
              _vm.openDialog = $$v
            },
            expression: "openDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-layout",
                    [
                      _c("v-flex", [
                        _vm._v(" " + _vm._s(_vm.alertMessage) + " ")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "c-pointer",
                              on: {
                                click: function($event) {
                                  _vm.openDialog = false
                                }
                              }
                            },
                            [_vm._v("\n              close\n            ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.showColumnsHeader && !_vm.hideColumnToggleBtn
        ? _c(
            "v-row",
            { staticClass: "sb_expand_column_header d-flex" },
            [
              _c(
                "v-col",
                { staticClass: "text-center col-12" },
                [
                  _c(
                    "v-tooltip",
                    {
                      attrs: { top: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function(ref) {
                              var on = ref.on
                              var attr = ref.attr
                              return [
                                _c(
                                  "v-btn",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        attrs: {
                                          depressed: "",
                                          fab: "",
                                          small: ""
                                        }
                                      },
                                      "v-btn",
                                      attr,
                                      false
                                    ),
                                    on
                                  ),
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.expandColumnHeader === false,
                                            expression:
                                              "expandColumnHeader === false"
                                          }
                                        ],
                                        attrs: { medium: "" },
                                        on: { click: _vm.headerColumntoggle }
                                      },
                                      [
                                        _vm._v(
                                          "\n              arrow_drop_down\n            "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-icon",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.expandColumnHeader === true,
                                            expression:
                                              "expandColumnHeader === true"
                                          }
                                        ],
                                        attrs: { small: "" },
                                        on: { click: _vm.headerColumntoggle }
                                      },
                                      [
                                        _vm._v(
                                          "\n              close\n            "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        98759471
                      )
                    },
                    [_vm._v(" "), _c("span", [_vm._v("Columns")])]
                  ),
                  _vm._v(" "),
                  _c("v-divider")
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-layout",
        [
          _c(
            "v-flex",
            [
              _vm._t("tableTopActions", null, {
                items: _vm.items,
                filteredItems: _vm.filteredItems,
                selectedItems: _vm.selectedItems
              })
            ],
            2
          ),
          _vm._v(" "),
          _vm.columnFilterable || _vm.downloadable
            ? _c(
                "div",
                { staticClass: "UDM_GS_HeaderIcons d-flex align-center" },
                [
                  _vm.columnFilterable
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            id: _vm.tableId + "-btn-filter_list",
                            icon: "",
                            flat: "",
                            depressed: "",
                            fab: "",
                            disabled: _vm.disableFiltersButton
                          },
                          on: { click: _vm.headerColumntoggle }
                        },
                        [
                          _c(
                            "v-tooltip",
                            {
                              attrs: { top: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      var attr = ref.attr
                                      return [
                                        _c(
                                          "v-icon",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass:
                                                  "material-icons-round filter-list"
                                              },
                                              "v-icon",
                                              attr,
                                              false
                                            ),
                                            on
                                          ),
                                          [_vm._v("filter_list")]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                3360441040
                              )
                            },
                            [
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  " Choose which table columns to display "
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.downloadable
                    ? _c(
                        "v-tooltip",
                        {
                          attrs: { top: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  var attr = ref.attr
                                  return [
                                    _c(
                                      "button",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            staticClass:
                                              "mr-0 sb_base_export_btn",
                                            attrs: {
                                              id: _vm.tableId + "-btn-download",
                                              disabled:
                                                _vm.disableDownloadButton
                                            },
                                            on: { click: _vm.exportTable }
                                          },
                                          "button",
                                          attr,
                                          false
                                        ),
                                        on
                                      ),
                                      [
                                        _c(
                                          "svg",
                                          {
                                            staticClass:
                                              "base-card-download-svg",
                                            attrs: {
                                              width: "13",
                                              height: "13",
                                              viewBox: "0 0 24 24",
                                              fill: "none",
                                              stroke: "currentColor",
                                              "stroke-width": "2",
                                              "stroke-linecap": "round",
                                              "stroke-linejoin": "round"
                                            }
                                          },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d:
                                                  "M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("polyline", {
                                              attrs: {
                                                points: "7 10 12 15 17 10"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("line", {
                                              attrs: {
                                                x1: "12",
                                                y1: "15",
                                                x2: "12",
                                                y2: "3"
                                              }
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [_vm._v("Export")])
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2490491029
                          )
                        },
                        [
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(" Download this table as a CSV file ")
                          ])
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.expandColumnHeader
        ? _c(
            "div",
            [
              _c(
                "v-layout",
                {
                  staticClass: "sb_columns_container",
                  attrs: { row: "", wrap: "" }
                },
                _vm._l(_vm.allHeaders, function(header, idx) {
                  return _c(
                    "v-btn",
                    {
                      key: idx,
                      attrs: {
                        id:
                          _vm.removeSpecialCharacters(header.value) + "_Header",
                        title: _vm.tooltips[header.value],
                        color: _vm.isUserHiddenHeader(header.value)
                          ? "outline"
                          : "",
                        dark: !_vm.isUserHiddenHeader(header.value)
                      },
                      on: {
                        click: function($event) {
                          return _vm.showOrHideHeader(header, _vm.allHeaders)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.rename[header.text] || header.text) +
                          "\n      "
                      )
                    ]
                  )
                }),
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("v-data-table", {
        ref: _vm.tableId,
        attrs: {
          id: _vm.tableId,
          value: _vm.selectedItems.map(function(x) {
            return x[_vm.itemKey]
          }),
          headers: _vm.headers,
          "hide-headers": _vm.hideHeaders,
          items: _vm.filteredItems,
          pagination: _vm.pagination,
          "hide-actions":
            _vm.noPaging ||
            (_vm.filterServerSide
              ? _vm.serverSideTotal <= _vm.initialPageLength
              : typeof _vm.items === "undefined" ||
                _vm.items.length <= _vm.initialPageLength),
          "select-all": _vm.selectable,
          "item-key": _vm.itemKey,
          dark: _vm.dark,
          "rows-per-page-items": _vm.rowsperpageitems,
          "total-items": _vm.serverSideTotal,
          loading: _vm.loading
        },
        on: {
          "update:pagination": function($event) {
            _vm.pagination = $event
          }
        },
        scopedSlots: _vm._u(
          [
            {
              key: "headers",
              fn: function(props) {
                return [
                  _c(
                    "tr",
                    [
                      _vm.selectable
                        ? _c(
                            "th",
                            {
                              staticClass:
                                "sb_table_selectAll_checkbox text-center"
                            },
                            [
                              _vm.maxSelections !== 1
                                ? _c(
                                    "span",
                                    [
                                      _vm.filterable
                                        ? _c(
                                            "filter-header",
                                            {
                                              attrs: {
                                                "hide-filter-input": "",
                                                "single-icon": ""
                                              }
                                            },
                                            [
                                              _c("v-checkbox", {
                                                staticClass:
                                                  "filterable-select-all",
                                                attrs: {
                                                  "input-value":
                                                    _vm.allSelected,
                                                  primary: "",
                                                  indeterminate:
                                                    _vm.partiallySelected,
                                                  "hide-details": "",
                                                  disabled: _vm.disabled
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.toggleAll($event)
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _c("v-checkbox", {
                                            attrs: {
                                              "input-value": _vm.allSelected,
                                              primary: "",
                                              indeterminate:
                                                _vm.partiallySelected,
                                              "hide-details": "",
                                              disabled: _vm.disabled
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.toggleAll($event)
                                              }
                                            }
                                          })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._t("header-left", null, { headers: _vm.headers }),
                      _vm._v(" "),
                      _vm._t(
                        "header-row",
                        _vm._l(_vm.headers, function(header, idx) {
                          return _c(
                            "th",
                            {
                              key: idx,
                              class: {
                                count_column:
                                  _vm.getColumnType(header.value) !== "text"
                              },
                              style: { padding: "2px" },
                              attrs: {
                                colspan: header.colspan || 1,
                                title: _vm.tooltips[header.value]
                              }
                            },
                            [
                              _vm._t(
                                header.value + "-header",
                                [
                                  _vm.filterable
                                    ? _c(
                                        "filter-header",
                                        {
                                          key: "" + _vm.filters[header.value],
                                          attrs: {
                                            label:
                                              _vm.rename[header.text] ||
                                              header.text,
                                            "filter-type":
                                              _vm.filterTypes[header.value],
                                            "is-sorted":
                                              _vm.pagination.sortBy ===
                                              "[" + header.value + "]",
                                            type: _vm.getColumnType(
                                              header.value
                                            ),
                                            value: _vm.filters[header.value],
                                            "sort-dir":
                                              _vm.pagination.sortBy ===
                                              "[" + header.value + "]"
                                                ? _vm.sortDir
                                                : "default",
                                            "previous-header-name":
                                              _vm.previousHeader,
                                            "hide-filter-input": _vm.hideFilters.includes(
                                              header.value
                                            )
                                          },
                                          on: {
                                            "updated:sort": function(e) {
                                              return _vm.updateSortDir(
                                                header.value,
                                                e
                                              )
                                            },
                                            "updated:filter": function(e) {
                                              return _vm.updateFilter(
                                                header.value,
                                                e
                                              )
                                            },
                                            "change:header": function(e) {
                                              return _vm.updatePreviousHeader(e)
                                            }
                                          },
                                          model: {
                                            value: _vm.filters[header.value],
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.filters,
                                                header.value,
                                                $$v
                                              )
                                            },
                                            expression: "filters[header.value]"
                                          }
                                        },
                                        [_vm._t(header.value + "-header-text")],
                                        2
                                      )
                                    : _c(
                                        "v-layout",
                                        { attrs: { "align-center": "" } },
                                        [
                                          _vm.sortable
                                            ? _c(
                                                "v-layout",
                                                {
                                                  staticClass:
                                                    "sb_basetable_sorticons",
                                                  attrs: { column: "" }
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        color:
                                                          _vm.pagination
                                                            .sortBy ===
                                                          "[" +
                                                            header.value +
                                                            "]"
                                                            ? _vm.sortDir ===
                                                              "asc"
                                                              ? "warning"
                                                              : undefined
                                                            : undefined
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.updateSortDir(
                                                            header.value,
                                                            "asc"
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [_vm._v("expand_less")]
                                                  ),
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        color:
                                                          _vm.pagination
                                                            .sortBy ===
                                                          "[" +
                                                            header.value +
                                                            "]"
                                                            ? _vm.sortDir ===
                                                              "desc"
                                                              ? "warning"
                                                              : undefined
                                                            : undefined
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.updateSortDir(
                                                            header.value,
                                                            "desc"
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [_vm._v("expand_more")]
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("v-flex", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.rename[header.text] ||
                                                  header.text
                                              )
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                ],
                                {
                                  value: header.text,
                                  header: header,
                                  headers: _vm.headers
                                }
                              )
                            ],
                            2
                          )
                        }),
                        { headers: _vm.headers }
                      ),
                      _vm._v(" "),
                      _vm._t("header-right", null, { header: _vm.headers }),
                      _vm._v(" "),
                      _vm.doAction
                        ? _c(
                            "th",
                            {
                              attrs: { id: "actionHeaderColumn", colspan: "1" }
                            },
                            [
                              _c("filter-header", {
                                attrs: {
                                  "hide-filter-input": "",
                                  label: "Action"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    2
                  )
                ]
              }
            },
            {
              key: "items",
              fn: function(props) {
                return [
                  _c(
                    "tr",
                    {
                      class: _vm.selected.includes(props.item[_vm.itemKey])
                        ? ""
                        : _vm.backgroundColorFunction(props.item),
                      attrs: {
                        active: _vm.selected.includes(props.item[_vm.itemKey])
                      },
                      on: {
                        click: function($event) {
                          return _vm.toggleItem(props.item, $event.target)
                        },
                        mouseenter: function($event) {
                          return _vm.mouseEntered($event, props.item)
                        },
                        mouseleave: function($event) {
                          return _vm.mouseLeave($event, props.item)
                        }
                      }
                    },
                    [
                      _vm.selectable
                        ? _c(
                            "td",
                            { staticClass: "sb_table_checkbox" },
                            [
                              props.item.selectable !== false &&
                              !_vm.disableSelect
                                ? _c("v-checkbox", {
                                    attrs: {
                                      "input-value": _vm.selected.includes(
                                        props.item[_vm.itemKey]
                                      ),
                                      primary: "",
                                      "hide-details": "",
                                      disabled:
                                        props.item.selectable === false ||
                                        _vm.disabled === true ||
                                        _vm.disableSelect
                                    }
                                  })
                                : _c(
                                    "v-icon",
                                    {
                                      class: props.item.noSelectIconColor,
                                      attrs: {
                                        title:
                                          props.item.noSelectMessage ||
                                          "This item is not selectable"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            props.item.noSelectIcon ||
                                              _vm.SbIcons.status.warn
                                          ) +
                                          "\n          "
                                      )
                                    ]
                                  )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._t("body-left", null, { item: props.item }),
                      _vm._v(" "),
                      _vm._l(_vm.headers, function(header, idx) {
                        return _c(
                          "td",
                          { key: idx, staticClass: "cellTextWrap" },
                          [
                            _c(
                              "v-tooltip",
                              {
                                attrs: {
                                  right: !_vm.topTooltip && idx == 0,
                                  left: !_vm.topTooltip && idx != 0,
                                  top: _vm.topTooltip,
                                  "max-width": "50%"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        var attrs = ref.attrs
                                        return [
                                          _c(
                                            "span",
                                            _vm._g(
                                              _vm._b({}, "span", attrs, false),
                                              on
                                            ),
                                            [
                                              _vm._t(
                                                header.value + "-body",
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        _vm.getDisplayValue(
                                                          props.item[
                                                            header.value
                                                          ],
                                                          _vm.types[
                                                            header.value
                                                          ]
                                                        )
                                                      ) +
                                                      "\n                "
                                                  )
                                                ],
                                                {
                                                  value:
                                                    props.item[header.value],
                                                  item: props.item
                                                }
                                              )
                                            ],
                                            2
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              },
                              [
                                _vm._v(" "),
                                _c("span", { staticClass: "wrapToolTip" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.getDisplayValue(
                                          props.item[header.value],
                                          _vm.types[header.value]
                                        )
                                      ) +
                                      "\n            "
                                  )
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _vm._t("body-right", null, { item: props.item }),
                      _vm._v(" "),
                      _vm.doAction
                        ? _c(
                            "td",
                            [
                              _vm._t(
                                "action-text",
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { small: "" },
                                      on: {
                                        click: function($event) {
                                          return _vm.deleteItem(_vm.item)
                                        }
                                      }
                                    },
                                    [_vm._v(" delete ")]
                                  )
                                ],
                                { item: props.item }
                              )
                            ],
                            2
                          )
                        : _vm._e()
                    ],
                    2
                  )
                ]
              }
            },
            _vm.hasFooterSlot ||
            _vm.displayTotals ||
            _vm.exportable ||
            _vm.tableOptions
              ? {
                  key: "footer",
                  fn: function() {
                    return [
                      _vm.displayTotals
                        ? _c(
                            "tr",
                            [
                              _vm.selectable ? _c("td") : _vm._e(),
                              _vm._v(" "),
                              _vm._l(_vm.headers, function(header, idx) {
                                return _c("td", { key: idx }, [
                                  idx === 0
                                    ? _c("span", [
                                        _c("b", [_vm._v("Grand Total")])
                                      ])
                                    : _vm.itemTotals[header.value] !== undefined
                                    ? _c("span", [
                                        _c("b", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getDisplayValue(
                                                _vm.itemTotals[header.value],
                                                _vm.types[header.value]
                                              )
                                            )
                                          )
                                        ])
                                      ])
                                    : _vm._e()
                                ])
                              })
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasFooterSlot || _vm.exportable || _vm.tableOptions
                        ? _c("tr", [
                            _c(
                              "td",
                              {
                                attrs: {
                                  colspan:
                                    _vm.headers.length +
                                    (_vm.selectable ? 1 : 0) +
                                    (_vm.extraColumn ? 1 : 0)
                                }
                              },
                              [
                                _vm._t("footer", null, {
                                  items: _vm.items,
                                  filteredItems: _vm.filteredItems,
                                  selectedItems: _vm.selectedItems
                                }),
                                _vm._v(" "),
                                _vm.exportable
                                  ? [
                                      _c(
                                        "v-btn",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.showDownloadIcon,
                                              expression: "showDownloadIcon"
                                            }
                                          ],
                                          attrs: { title: "Download CSV" },
                                          on: { click: _vm.exportTable }
                                        },
                                        [
                                          _c("v-icon", [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.SbIcons.export.default
                                                ) +
                                                "\n              "
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          ])
                        : _vm._e()
                    ]
                  },
                  proxy: true
                }
              : null,
            {
              key: "no-data",
              fn: function() {
                return [
                  _c(
                    "v-alert",
                    {
                      staticClass: "sb_NoDataAvialable",
                      attrs: {
                        value: "true",
                        color: "#fbfbfb",
                        icon: "warning"
                      }
                    },
                    [
                      _vm._t("default", [
                        _vm._t("no-data", [
                          _vm.loading
                            ? _c("span", [_vm._v(" Loading... ")])
                            : _c("span", [_vm._v(" No Data Available ")])
                        ])
                      ])
                    ],
                    2
                  )
                ]
              },
              proxy: true
            },
            {
              key: "pageText",
              fn: function(ref) {
                var pageStart = ref.pageStart
                var pageStop = ref.pageStop
                var itemsLength = ref.itemsLength
                return [
                  _vm._t(
                    "page-text",
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(pageStart) +
                          " - " +
                          _vm._s(pageStop) +
                          " of " +
                          _vm._s(itemsLength) +
                          "\n      "
                      )
                    ],
                    {
                      pageStart: pageStart,
                      pageStop: pageStop,
                      itemsLength: itemsLength
                    }
                  )
                ]
              }
            }
          ],
          null,
          true
        )
      }),
      _vm._v(" "),
      _c(
        "v-snackbar",
        {
          attrs: { top: "", color: "warning" },
          model: {
            value: _vm.snackbar,
            callback: function($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar"
          }
        },
        [_vm._v("\n    " + _vm._s(_vm.snackbarMessage) + "\n  ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }